import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../../hook/useRulesContext";
import FieldWrapper from "../../../../../../components/UI/common/FieldWrapper";
import MultiSelect from "../../../../../../components/UI/MultiSelect";

export default function UsersSettings() {
    const {
        shortcodeFormData: formData,
        userRoles: availableUserRoles,
        handleInputChange,
    } = useRulesContext();

    return (
        <FieldWrapper
            label={__("User Roles", "wpbean-quantity-controls-for-woocommerce")}
            description={__(
                "Restrict to specific user roles",
                "wpbean-quantity-controls-for-woocommerce",
            )}
            direction="vertical"
            fieldsClass=""
        >
            <MultiSelect
                name="user_roles"
                value={formData.user_roles}
                onChange={handleInputChange}
                placeholder="Search user role"
                options={availableUserRoles} // ← Pass options directly
                // responseType="array" is default, no need to specify
                isMulti={true}
            />
        </FieldWrapper>
    );
}
